export default __webpack_public_path__ + "static/media/esg-report.e4e0ab4c.jpg";